export default {
  "fr": {
    "todo_list": {
      "actions": {
        "add": "Ajouter Liste de Tâches",
        "cancel": "Annuler",
        "delete_todo_list": "Supprimer liste de tâches",
        "edit": "Modifier",
        "new": "Nouvelle Liste de Tâches",
        "save": "Enregistrer",
        "title": "Titre"
      },
      "attributes": {
        "name": "Titre"
      },
      "labels": {
        "assignToLevel": "Attribuer au niveau",
        "newTodoList": "Nouvelle Liste de Tâches"
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Gardez un aperçu de ce que vous et votre équipe devez faire.",
            "title": "Ouvrir une nouvelle Liste de Tâches"
          }
        }
      },
      "toasts": {
        "create": "Liste de Tâches créée",
        "delete": "Liste de Tâches supprimée",
        "update": "Liste de Tâches mise à jour"
      },
      "validation": {
        "needTitle": "Titre requis"
      }
    }
  }
}